/* eslint-disable jsx-a11y/anchor-is-valid */

'use client';

import Link from 'next/link';

// Import Icons
import FeatherIcon from 'feather-icons-react';
import { useEffect, useState } from 'react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hydrated, setHydrated] = useState(false);

  const toTop = () => {
    if (typeof window === 'undefined') return;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const backToTopButton = () => {
    if (typeof window === 'undefined') return;

    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScroll = () => { backToTopButton(); };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!hydrated) return null;

  return (
    <Link
      href="#"
      onClick={() => toTop()}
      id="back-to-top"
      className="btn btn-icon btn-primary back-to-top"
      style={{ display: isVisible ? 'block' : 'none' }}
    >
      <FeatherIcon icon="arrow-up" className="icons" />
    </Link>
  );
};

export default BackToTop;
